import { stringify } from 'qs';
import request from '../utils/request';

export async function getList(params, noti = true) {
  return request(`v1/api/user/users?${stringify(params)}`, null, noti);
}

export async function get(id, params = {}) {
  if (params) {
    return request(`v1/api/user/info/${id}?${stringify(params)}`);
  }
  return request(`v1/api/user/info/${id}`);
}

export async function create(body) {
  return request(`v1/api/user/register-username`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`v1/api/user/info/${id}`, {
    method: 'POST',
    body,
  });
}